import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import React from 'react';

// antd mặc định dùng icon Filled (nền tô đặc màu, icon trắng ở giữa) cho notification.
// Đổi sang icon Outlined (nền trắng, chỉ viền + icon tô màu) đồng bộ với hooks/useNotification.js.
const showSuccessMessage = (content, translate) => {
    notification.success({
        message: 'Thành công',
        description: content,
        icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
    });
};

const showErrorMessage = (content, translate) => {
    notification.error({
        message: 'Lỗi',
        description: content,
        icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
    });
};

const showWarningMessage = (content, translate) => {
    notification.warning({
        message: 'Cảnh báo',
        description: content,
        icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
    });
};

export { showErrorMessage, showWarningMessage, showSuccessMessage };
